module.exports = __webpack_public_path__ + "/img/Header-Female-Straight-Labeled-sYN8vW.svg";